export const ORG_MEMBER_TYPES = {
  ALL: 'ALL',
  MEMBER: 'MEMBER',
  ADMIN: 'ADMIN',
} as const;

export type OrgMemberType = typeof ORG_MEMBER_TYPES[keyof typeof ORG_MEMBER_TYPES];